import React, { useEffect } from 'react'
//import {Realtime} from 'ably/browser/static/ably-commonjs.js';
import {NativeEventSource, EventSourcePolyfill} from 'event-source-polyfill';
import { useSelector } from 'react-redux'
import { setAblyConnectionToken } from 'virtual_congress/actions'
import axios from 'axios'
import { useBeforeunload } from 'react-beforeunload';
import useStateRef from 'react-usestateref'
import { serializeError } from 'serialize-error'
import useInterval from '@use-it/interval'
import { sample } from 'lodash'

import { setWindowConnectionState } from '../websocket_connection.jsx'


const EventSource = NativeEventSource || EventSourcePolyfill;
// OR: may also need to set as global property
global.EventSource = NativeEventSource || EventSourcePolyfill;

export default function AblyConnection({ onMessageCompleted, channels, onReceive, ...props}) {
  //console.log("Connecting to ably via", authToken, privateChannelName)

  const [renderedConnectionState, setConnectionState, connectionState] = useStateRef("connecting")
  // Calculate channels
  const enabled = useSelector(state => state.websocket?.ably?.enabled)
  const [authToken, setAuthToken] = useStateRef(useSelector(state => state.websocket?.ably?.connectionToken))
  const authTokenUrl = useSelector(state => state.connectionTokenUrl) || "/public/ably_connection_tokens"
  const [errorsSent, setErrorsSent] = useStateRef(0)

  const [lastAblyEventId, setLastAblyEventId] = useStateRef(null)
  const [errorTries, setErrorTries] = useStateRef(10)
  const [url, setUrl] = useStateRef(null)
  const [currentUrlIndex, setCurrentUrlIndex] = useStateRef(0)

  const ablyUrls = [
    "flave-realtime.ably.io",
    "flave-a-fallback.ably-realtime.com",
    "flave-b-fallback.ably-realtime.com",
    "flave-c-fallback.ably-realtime.com",
    "flave-d-fallback.ably-realtime.com",
    "flave-e-fallback.ably-realtime.com",
  ]

  let eventSource = null

  /**
   * Contains all incoming message chunks.
   */
  let incomingMessages = {}

  const handleMessageChunk = (type, messageChunk) => {

    // The keys are chosen to be short so ...
    // id Is the message id - used to group a message together
    // tc Total chunks - Determines the total amount of chunks
    // ci Chunk index - The number of the current chunk.
    if (messageChunk.id && messageChunk.tc && (messageChunk.ci || messageChunk.ci === 0)) {
      // Initialize if not already initialized.

      if(incomingMessages[messageChunk.id] === undefined) {
        incomingMessages[messageChunk.id] = {}
      }

      incomingMessages[messageChunk.id][messageChunk.ci] = messageChunk

      console.log("[Ably] receiving message chunk", messageChunk)


      let isMessageComplete = Object.keys(incomingMessages[messageChunk.id]).length == messageChunk.tc

      //console.log("MESSAGE PARTS", isMessageComplete,incomingMessages[messageChunk.id], "as", messageChunk.tc, "as")
      // DOESNT WORK IF PACKETS DONT COME IN THE RIGHT ORDER!!!
      // for (let i = 0; i < messageChunk.tc; i++) {
      //   // console.log("Trying to build message ----- ", i, incomingMessages[messageChunk.id][i])
      //   console.log(incomingMessages[messageChunk.id])
      //   if (incomingMessages[messageChunk.id][i]) {
      //     completeMessage += incomingMessages[messageChunk.id][i].d;
      //     // console.log("putting message chunk together", incomingMessages[messageChunk.id][i].d)
      //   } else {
      //     // console.log("message not complete yet", completeMessage)
      //     isMessageComplete = false
      //     break
      //   }
      // }

      if (isMessageComplete) {
        let completeMessage = ""
        for (let i = 0; i < messageChunk.tc; i++) {
          completeMessage += incomingMessages[messageChunk.id][i].d;
        }

        delete incomingMessages[messageChunk.id]
        console.log("[Ably] message completed", JSON.parse(completeMessage), incomingMessages)
        onReceive ? onReceive({type: type, payload: JSON.parse(completeMessage)}) : onMessageCompleted("ably", messageChunk.id, {type: type, payload: JSON.parse(completeMessage)})
      } else {
        //console.log("No finished message", messageChunk)
      }
    }
  }

  const sendError = (err) => {
    let serializedError = serializeError(err)

    if(errorsSent > 3) {
      console.error("[Ably] Not reporting further debug errors")
    } else {
      console.error("[Ably] Sending debug error call", err.data, serializedError)
      if(err.data) {
        serializedError.data = err.data
      }
      setErrorsSent(errorsSent + 1)
      // axios.post("/public/provider_log_entry", { error: serializedError}).then((response) => {
      //   console.warn("provider_log_entry", response)
      // })
    }
  }

  const connectToAbly = (authToken) => {
    try {
      const lastEventParam = lastAblyEventId ? ('&lastEvent=' + lastAblyEventId) : '';



      const currentUrl = ablyUrls[currentUrlIndex % ablyUrls.length]
      setCurrentUrlIndex(currentUrlIndex + 1)
      setUrl(currentUrl)

      console.debug("Connecting to ably:", authToken, {lastEventParam}, currentUrl)
      if(channels.length == 0) {
        console.error("[Ably] NO CHANNEL CONFIGURATION SET!!!! connecting to public at least")
        channels = ["public"]
      }

      const fullUrl = `https://${currentUrl}/sse?v=1.2&accessToken=${authToken}&channels=${channels.join(",")}${lastEventParam}`
      eventSource = new EventSource(fullUrl);
      eventSource.onopen = () => {
        setConnectionState("connected")
        console.debug("Connection to server opened.", fullUrl);
        setWindowConnectionState("ably", true)
      };
      // handle incoming messages
      eventSource.onmessage = message => {
        if(connectionState.current != "connected") {
          setConnectionState("connected")
        }
        //lastEvent = message.lastEventId
        setLastAblyEventId(message.lastEventId)
        //console.log("received", message)
        //console.log("DATA", message.data)
        let msg = JSON.parse(message.data)
        handleMessageChunk("CABLE_" + msg.name, JSON.parse(msg.data))
        //console.table(incomingMessages)
        // store.dispatch({type: "CABLE_" + msg.name, payload: JSON.parse(msg.data)})
      }

      // handle connection errors
      eventSource.onerror = msg => {
        console.error(msg)
        let err = null
        let isTokenErr = false

        if(msg.data) {
          err = JSON.parse(msg.data);
          isTokenErr = err.code >= 40140 && err.code < 40150;
        }

        if(connectionState.current != "unloading") {
          //if (!isTokenErr) {
            sendError(msg)
          //}
          setConnectionState("closed")
        }
        setWindowConnectionState("ably", false)
        console.warn("[Ably] Ably connection closed completely!", url)
        try {
          eventSource.close();
        } catch(ex) {
          console.error(ex)
        }
        //axios({
        //  url: authTokenUrl,
        //  timeout: 4000,
        //  method: "POST"
        //}).then((response) => {
        //  if(response.data.status == "OK") {
        //    console.warn("Setting new ably token", response.data.authToken)
        //    setAuthToken(response.data.authToken)
        //  } else {
        //    console.error("Token refresh failed", response)
        //  }
        //})
      }
    } catch(e) {
      sendError(e)
    }
  }

  useBeforeunload(() => {
    setConnectionState("unloading")
    console.debug("Unloading", {connectionState})
  })

  useEffect(() => {
    connectToAbly(authToken)

    return () => {
      setWindowConnectionState("ably", false)

      if(connectionState.current != "unloading")
        setConnectionState("closed")
      eventSource.close();
    }
  }, [])

  useInterval(() => {
    if(connectionState?.current != "connected") {
      connectToAbly(authToken)
      setErrorTries(errorTries + 1)
    }
  }, errorTries * 1000)

  if(!enabled) {
    console.warn("[Ably] Ably disabled")
    return <></>
  }

  switch(connectionState?.current) {
    case "connecting":
      return <div className="network-status network-status-warning">
        <i className="fa fa-spinner fa-spin"></i>{" "}
        Connecting to Ably {url}...
      </div>
    case "connected":
      return <div className="network-status network-status-success">
        <i className="fa fa-check"></i>{" "}
        Ably connected
      </div>
    case "closed":
      return <div className="network-status network-status-danger">
        <i className="fa fa-times"></i>{" "}
        Ably connection failed
      </div>
    case "unloading":
      return <></>
    default:
      return <div className="network-status network-status-danger">Unknown connection state</div>
  }

  return <></>
}


// Websocket connection. We dont like that, since we dont need bidirectional calls
// export function startConnection(store, authToken, privateChannelName) {
//   const Ably = new Realtime(authToken);
//   Ably.connection.on('connected', function() {
//     console.log("Connected to Ably")
//   });
//   const public_channel = Ably.channels.get('public');
//   public_channel.subscribe(function(message) {
//     console.info("Received message", message)
//     store.dispatch({type: "CABLE_" + message.name, payload: message.data })
//   });

//   const private_channel = Ably.channels.get(privateChannelName);
//   private_channel.subscribe(function(message) {
//     console.info("Received private message", message)
//     store.dispatch({type: "CABLE_" + message.name, payload: message.data })
//   });

//   public_channel.subscribe(function(message) {
//     console.info("Received message", message)
//     store.dispatch({type: "CABLE_" + message.name, payload: message.data })
//   });

//   return Ably;
// }
